// extracted by mini-css-extract-plugin
export var searchHeader = "_2d-0";
export var searchHeaderDark = "_2d-1";